<div
  [ngClass]="{
    stack: childArrangement() == 'STACK',
    adjacent: childArrangement() == 'ADJACENT',
  }"
  [ngStyle]="containerStyle()"
>
  @for (slot of allChildData(); track slot; let i = $index) {
    @if (slot.slotType == 'LOGICAL') {
      <view-container
        [autoSuggestMenuData]="autoSuggestMenuData()"
        [parentId]="slot.id"
        [dynamicSlots]="dynamicSlots()"
        [allChildData]="getRequiredDataforLogical(slot.id)"
        [childArrangement]="slot.childArrangement"
        [allSlotsData]="allSlotsData()"
        [ngClass]="widgetsService.cssClassMap.get(slot.id)"
        [containerStyle]="widgetsService.cssStylesMap.get(slot.id)"
        [layoutParams]="slot.layoutParams"
        [actionEvent]="actionInput"
        [actionResponseContext]="actionResponseContext()"
        [userContextDto]="userContextDto()"
        [inputUserSession]="inputUserSession()"
      ></view-container>
    }
    @if (slot.slotType == 'WIDGET') {
      @if (dynamicSlots().get(slot.widget.type)) {
        @let deferEnabled = slot?.widget?.defer?.enabled && slot?.widget?.defer?.deferStrategy == HydrationAndDeferType.VIEWPORT;
        @let hydrationEnabled = slot?.widget?.defer?.enabled && slot?.widget?.defer?.hydrationStrategy == HydrationAndDeferType.VIEWPORT;
        <ng-template #widgetTemplate let-slot="slot">
          <ng-container
            *ngComponentOutlet="
              dynamicSlots().get(slot.widget.type);
              inputs: renderWidget(slot, actionInput, autoSuggestMenuData(), userContextDto(), inputUserSession(), actionResponseContext())
            "
          ></ng-container>
        </ng-template>
        @if (deferEnabled) {
          @defer(on viewport(placeholder)){
            <ng-container *ngTemplateOutlet="widgetTemplate; context: { slot: slot }"></ng-container>
          } @placeholder {
            <div #placeholder></div>
          }
        } @else if(hydrationEnabled){
          @defer (when hydrationEnabled; hydrate on viewport) {
            <ng-container *ngTemplateOutlet="widgetTemplate; context: { slot: slot }"></ng-container>
          }
        } @else{
          <ng-container *ngTemplateOutlet="widgetTemplate; context: { slot: slot }"></ng-container>
        }
      } @else {
        <!-- <div 
          [ngClass]="widgetsService.cssClassMap.get(slot.id)"
          [ngStyle]="widgetsService.cssStylesMap.get(slot.id)">
        </div> -->
        <p
          style="
            padding: 20px;
            background-color: rgb(196, 219, 196);
            border: 1px solid black;
            width: 100%;
          "
        >
          {{ slot.id }} {{ slot.parentId }} {{ slot.widget.type }}
        </p>
      }
    }
  }
</div>
